import { Checkbox, FormControl, FormLabel, Text } from "@chakra-ui/react";
import React, { memo, useCallback } from "react";
import { useForm } from "react-hook-form";
import { NodeProps, useReactFlow, useUpdateNodeInternals } from "reactflow";
import { NodeType } from "../../../models/nodeType";
import { FlowNodeWithChildren } from "./FlowNode";

interface FormData {
  grantRewards: boolean;
}

const CompleteQuestLogNode: React.FC<NodeProps<NodeType>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData = [], sourceHandles = [] },
  } = props;

  const formData = nodeData as FormData | undefined;
  const grantRewards = formData?.grantRewards ?? false;

  const { register, handleSubmit } = useForm<FormData>({
    defaultValues: {
      grantRewards,
    },
    mode: "onChange",
  });

  const reactFlow = useReactFlow();
  const updateNodeInternals = useUpdateNodeInternals();

  const handleUpdate = useCallback(
    ({ grantRewards }: FormData) => {
      reactFlow.setNodes((nodes) => {
        const node = nodes.find(({ id }) => id === nodeId);

        if (node == null) {
          return nodes;
        }

        const nodeDataCloned = structuredClone(node.data) as NodeType;

        const nodeData = (nodeDataCloned.nodeData as FormData) ?? {};
        nodeData.grantRewards = grantRewards;

        node.data = {
          ...nodeDataCloned,
          nodeData,
        };

        return nodes;
      });

      updateNodeInternals(nodeId);
    },
    [reactFlow, nodeId, sourceHandles]
  );

  return (
    <>
      <FlowNodeWithChildren {...props}>
        <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onChange={handleSubmit(handleUpdate)}>
          <FormControl>
            <FormLabel>
              <Text casing={"uppercase"} color={color}>
                Grant Rewards
              </Text>
            </FormLabel>
            <Checkbox {...register("grantRewards")} color={color} />
          </FormControl>
        </form>
      </FlowNodeWithChildren>
    </>
  );
};

export default memo(CompleteQuestLogNode);
